import { useContext } from 'react';
import { ConfigContext } from 'src/configContext';
import { LocationStateContext } from 'src/sensors/locationStateContext';
import { RegionsEnum } from 'src/generated/operations';
import { UNIT_SWITCH_COUNTRIES } from 'src/sensors/constants';

export const useImperial = () => {
    const { userSettings } = useContext(ConfigContext);
    const { locationState } = useContext(LocationStateContext);

    const showSwitch = UNIT_SWITCH_COUNTRIES.includes(userSettings.currentCountry);

    if (locationState.isImperial !== null) {
        return {
            isImperial: locationState.isImperial,
            showSwitch,
        };
    }

    if (showSwitch) {
        return {
            isImperial: false,
            showSwitch: true,
        };
    }

    return {
        isImperial: userSettings.currentRegion === RegionsEnum.Am,
        showSwitch,
    };
};
